import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import {
  InvoiceStatus,
  useSubscriptionPaymentHistoryTabQuery
} from 'generated/graphql';
import { useParams } from 'react-router-dom';

export type SubscriptionPaymentHistoryTab = {};

export const FC = (props: SubscriptionPaymentHistoryTab) => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const { data, loading } = useSubscriptionPaymentHistoryTabQuery({
    skip: !organizationId,
    variables: {
      organizationId: organizationId ?? ''
    }
  });

  return (
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableRow>
            {/* <TableCell variant='head'>
              Method
            </TableCell> */}

            <TableCell variant='head'>
              Due Date
            </TableCell>

            <TableCell variant='head'>
              Payment Date
            </TableCell>

            <TableCell variant='head'>
              Amount
            </TableCell>

            <TableCell variant='head'>
              Amount Due
            </TableCell>

            <TableCell variant='head'>
              Status
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data?.invoices.map((i) => (
            <TableRow key={i.id}>
              {/* <TableCell>
                A
              </TableCell> */}

              <TableCell>
                {i.dueDate?.toFormat('MM/dd/yyyy') ?? '-'}
              </TableCell>

              <TableCell>
                {i.paymentDate?.toFormat('MM/dd/yyyy') ?? '-'}
              </TableCell>

              <TableCell>
                {i.amount?.toFixed(2) ?? '-'}
              </TableCell>


              <TableCell>
                {i.amountDue?.toFixed(2) ?? '-'}
              </TableCell>

              <TableCell>
                <Chip
                  variant={__getStatusChipVariant(i)}
                  color='success'
                  label={i.status.toUpperCase()}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

  );
};



function __getStatusChipVariant(i: { status: InvoiceStatus }) {
  if (i.status === 'paid') {
    return 'active'; // a bright green for some reason.
  }

  if (i.status === 'failed') {
    return 'error';
  }

  return 'warn';
}

